import type { ThemeRegistryEntry } from "../contracts";

export const SYNTAX_TOKEN_TO_CSS_VARIABLE = {
    keyword: "--syntax-keyword",
    string: "--syntax-string",
    comment: "--syntax-comment",
    number: "--syntax-number",
    function: "--syntax-function",
    variable: "--syntax-variable",
    type: "--syntax-type",
    link: "--syntax-link",
    tag: "--syntax-tag",
    attribute: "--syntax-attribute",
    heading: "--syntax-heading",
    emphasis: "--syntax-emphasis",
    strong: "--syntax-strong",
    strikethrough: "--syntax-strikethrough",
    quote: "--syntax-quote",
    code: "--syntax-code",
    separator: "--syntax-separator",
    list: "--syntax-list",
    bracket: "--syntax-bracket",
    operator: "--syntax-operator",
} as const;

export type SyntaxTokenId = keyof typeof SYNTAX_TOKEN_TO_CSS_VARIABLE;

const SYNTAX_TOKEN_METADATA = {
    keyword: "Keywords and control flow.",
    string: "Strings and attribute values.",
    comment: "Comments and meta text.",
    number: "Numbers and constants.",
    function: "Function and method names.",
    variable: "Variables and property names.",
    type: "Type names.",
    link: "Links and URLs.",
    tag: "Markup tags.",
    attribute: "Markup attributes.",
    heading: "Headings.",
    emphasis: "Emphasis text.",
    strong: "Strong text.",
    strikethrough: "Strikethrough text.",
    quote: "Quotes and quote-like text.",
    code: "Inline code and monospace text.",
    separator: "Separators and hr markers.",
    list: "List markers.",
    bracket: "Punctuation and brackets.",
    operator: "Operators.",
} as const satisfies Record<SyntaxTokenId, string>;

export const SYNTAX_TOKEN_REGISTRY: ThemeRegistryEntry<SyntaxTokenId>[] = (
    Object.keys(SYNTAX_TOKEN_TO_CSS_VARIABLE) as SyntaxTokenId[]
).map((id) => ({
    id,
    cssVariable: SYNTAX_TOKEN_TO_CSS_VARIABLE[id],
    description: SYNTAX_TOKEN_METADATA[id],
    domain: "editor",
    public: true,
}));

export const KNOWN_SYNTAX_TOKEN_VARIABLES = Object.values(
    SYNTAX_TOKEN_TO_CSS_VARIABLE,
);

export const SYNTAX_CSS_VARIABLE_TO_TOKEN = Object.fromEntries(
    Object.entries(SYNTAX_TOKEN_TO_CSS_VARIABLE).map(([id, cssVariable]) => [
        cssVariable,
        id,
    ]),
) as Record<(typeof KNOWN_SYNTAX_TOKEN_VARIABLES)[number], SyntaxTokenId>;
